module.exports = __webpack_public_path__ + "img/Mask02_uv_print1-01.ddc89710.svg";